<div class="flex flex-col items-center" [formGroup]="errorForm" *transloco="let t">
	<ng-container>
		<vis-ods-icon-component
			name="zeissLogo"
			width="48px"
			height="48px"
			class="mt-s"
		></vis-ods-icon-component>
		<div class="w-full items-start mt-s text-center">
			<beyond-online-headline
				class="mt-s"
				[headline]="popUpConfig.data?.headline || ''"
				size="s"
			></beyond-online-headline>
			<p class="mb-s" beyond-online-text>
				{{ popUpConfig.data?.description }}
				<a [href]="myZeissUrl" class="text-interaction-link"> MyZEISS</a>
			</p>
		</div>
		<beyond-online-text-area
			class="w-full mb-m"
			[title]="t('generalComponents.reportIssuePopup.inputs.issue.label')"
			[helperText]="t('generalComponents.reportIssuePopup.inputs.issue.helperTexts.base')"
		>
			<textarea beyondInput type="text" formControlName="description"></textarea>
		</beyond-online-text-area>
		<button
			[disabled]="isSubmitting"
			beyond-online-button
			[label]="t('generalComponents.reportIssuePopup.buttons.submit')"
			class="w-full flex justify-center mb-xs"
			(click)="submitTicket()"
		></button>
	</ng-container>
</div>
